import { css, LitElement, html } from 'lit-element';
import { safeDefine } from 'lm-ui-kit/src/utils/define-element';

class UcAdeoLinks extends LitElement {
  static styles = css`
    :host {
      display: flex;

      align-items: center;
      justify-content: space-between;

      height: 100%;
    }
  `;

  render() {
    return html` <slot class="content"></slot> `;
  }
}

safeDefine('uc-adeo-links', UcAdeoLinks);
